import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NucleusUser, UserEditPayloadEvent } from '@nucleus/user-ui';

/**
 * Tasksense user-edit thin shell over &lt;lib-user-edit&gt;. The library handles
 * username parsing, role tree, FormGroup composition and the save round-trip;
 * this shell just builds the TaskSenseCreate/UpdateUserPayload shapes the
 * backend expects (userId + fullName + email + roles).
 *
 * Tasksense has no org-units / locations projection — the lib's default
 * 2-tab layout (User Information + Security) is all we need.
 */
@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrl: './user.component.css',
  standalone: false,
})
export class UserComponent {
  private readonly route = inject(ActivatedRoute);

  /** Username from the :id route param — empty on the create flow. */
  userIdParam = this.route.snapshot.paramMap.get('id') || '';

  buildTaskSenseCreatePayload(event: UserEditPayloadEvent): void {
    event.emit({
      userId: event.user.username,
      fullName: event.user.name,
      email: event.user.email,
      roles: event.user.authorities,
    });
  }

  buildTaskSenseUpdatePayload(event: UserEditPayloadEvent): void {
    event.emit({
      userId: this.userIdParam || event.user.username,
      fullName: event.user.name,
      email: event.user.email,
      roles: event.user.authorities,
    });
  }

  onUserSaved(user: NucleusUser): void {
    if (user.username) this.userIdParam = user.username;
  }
}
